import Tag from '@rio-cloud/rio-uikit/Tag';
import TelematicsName from './TelematicsName';
import type { AssetDevicesProps } from './types';

export const AssetDevices = (props: AssetDevicesProps) => (
    <ul className='list-inline margin-bottom-0'>
        {props.assetDevices.map(associatedDevice => (
            <li key={associatedDevice.device.id} className='margin-1'>
                <Tag size={'small'}>
                    <TelematicsName deviceType={associatedDevice.device.type} />{' '}
                </Tag>
            </li>
        ))}
    </ul>
);
